<template>
  <div>
    <router-view/>
    <vue-snotify></vue-snotify>
  </div>
</template>

<script>

export default {
  name: 'App'
}
</script>

<style>
@font-face {
  font-family: "digital-clock-font";
  src: local("digital-clock-font"),
   url(./fonts/DS-DIGII.TTF) format("truetype");
}
</style>
